import React, {useContext} from 'react';
import {LangContext} from '../../../components/LangProvider/LangProvider';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import copyObj from '../../../utils/copyObj'
import config from '../../../data/config';
import doRecursiveChangeKeys from '../../../utils/doRecursiveChangeKeys'
import {saveCut, loadCut, clearCut} from '../../../utils/loadAndSaveData';


function MyModalShare(props){
  const {showShare, setShowShare, selected, userid, searchKeyword} = props
  const {lang} = useContext(LangContext);
  const t = lang.mymodalshare;
  const cut = loadCut() || {}
  //** functions */
  const handleClose = ()=>{
    setShowShare(false)
  } 
  const handleCopyCancel = ()=>{
    clearCut()
    setShowShare(false)
  } 
  const handleCopy = () => {
    if(selected.type === 'pge'){
      alert(t['pageCopy_error'])
      return 
    }else{
      const copied = copyObj(selected)
      doRecursiveChangeKeys(copied)
      cut.source = copied
      if(userid === config.defaultUserid){
        // do nothing
      }else{
        // to inform 'copy' to server
        cut.source.kind = 'copy'
      }
      // setCut(cut)
      saveCut(cut)
      handleClose()

    }
  }
  const baseUrl = window.location.origin;
  //** props */
  return(
    <Modal show={showShare} onHide={handleClose} className="MyModal">
      <Modal.Footer>
          {selected.type === 'pge' &&
            <>
            <span className="message">{t.copywidget}</span>
            <textarea readOnly rows="4" cols="50" defaultValue={`<iframe src="${baseUrl}/share/${searchKeyword}" width="320px" height="400px" border="none"></iframe>`}>
            </textarea>
            <span className="message">{t.copyurl}</span>
            <span className="message">{`${baseUrl}/share/YourWord`}</span>
            </>
          }
          {!cut.source && selected.type !== 'pge' &&
          <>
          <span>{t.copyquestion}</span><span>{t.type[selected.type]}{': '}{selected.title}</span>
          <Button variant="info" onClick={handleCopy}>
            {t.copy}
          </Button>
          </>
          }
          {cut.source && selected.type !== 'pge' &&
          <>
            <span>{t.copyguide}</span>
            <Button variant="success" onClick={handleCopyCancel}>
              {t.cancelcopy}
            </Button>
          </>
          }
        <Button variant="secondary" onClick={handleClose}>
          {t.close}
        </Button>
        {selected.type === 'pge' &&
        <Button variant="info">
          <a href={t.companyurl} target="_blank" rel="noopener noreferrer">{t.companyname}</a>
        </Button>
        } 
      </Modal.Footer>
    </Modal>
  );
}

export default MyModalShare;